import {
    fadeIn,
    fadeOut
} from "LocalPackages/Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/Functions/Animations";

export function scrollToTop(): void {
    const scrollToTopButton = document.querySelector('.to-top-link') as HTMLElement;
    if (!scrollToTopButton) {
        return;
    }

    scrollToTopButton.style.display = 'none';
    const toTopOffset = window.innerHeight;
    let visible = false;

    window.addEventListener('scroll', () => {
        if (window.scrollY > toTopOffset) {
            if (!visible) {
                visible = true;
                fadeIn(scrollToTopButton);
                document.body.classList.add('scroll-to-top-show');
            }
        } else {
            if (visible) {
                visible = false;
                fadeOut(scrollToTopButton);
                document.body.classList.remove('scroll-to-top-show');
            }
        }
    });
}
